import axios from "axios";
// import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

export default {
    // Transport
    getTransportList({ dispatch, commit }) {
        axios
            .get("Transport/ListTransportHeader?Page=1&PageSize=10000")
            .then((res) => {
                commit("setTransportList", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },

    getTransportDetails({ dispatch, commit }, data) {
        axios
            .get("Transport/GetTransportDtl/" + data)
            .then((res) => {
                commit("setTransportDetails", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },


    // other Supports API
    getGifts({ dispatch, commit }) {
        axios
            .get("User/ListDonate?Page=1&PageSize=10000")
            .then((res) => {
                commit("setGifts", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },

    getFoodList({ dispatch, commit }) {
        axios
            .get("Food/ListDiet")
            .then((res) => {
                commit("setFoodList", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },

    getCalendarList({ dispatch, commit }, data) {
        axios
            .get("Week/ListWeek?date=" + data)
            .then((res) => {
                commit("setCalendarList", res.data.result.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },


};
